// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3BGsT","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1Uned","obliqueLine":"membershipbadge_obliqueLine__3TnJ9"};